/** en-GB messages for the Platform "Email server" settings (task p2/smtp). Flat keys, merged into enGB by ./index.ts. */
export const smtpEnGB = {
    'emailServer.title': 'Email server',
    'emailServer.description': 'The server CloudSign uses to send email. Saved here, it replaces the server\'s environment variables.',
    'emailServer.source.environment': 'Nothing is saved here yet, so the settings in the server\'s environment variables are in use. Saving this form replaces them.',
    'emailServer.source.database': 'Using the settings saved here.',
    'emailServer.transport': 'Delivery',
    'emailServer.transport.smtp': 'Send through an SMTP server',
    'emailServer.transport.file': 'Do not send: write messages to files (testing only)',
    'emailServer.host': 'Server name',
    'emailServer.host.hint': 'For example smtp.example.com',
    'emailServer.port': 'Port',
    'emailServer.security': 'Security',
    'emailServer.security.none': 'None (not encrypted)',
    'emailServer.security.starttls': 'STARTTLS (usually port 587)',
    'emailServer.security.tls': 'TLS (usually port 465)',
    'emailServer.username': 'User name',
    'emailServer.username.hint': 'Leave empty if the server needs no sign-in.',
    'emailServer.password': 'Password',
    'emailServer.password.set': 'A password is set.',
    'emailServer.password.notSet': 'No password is set.',
    'emailServer.password.change': 'Change password',
    'emailServer.password.cancel': 'Keep the saved password',
    'emailServer.password.clear': 'Remove the saved password',
    'emailServer.password.new': 'New password',
    'emailServer.allowInsecureAuth': 'Allow sign-in without encryption',
    'emailServer.allowInsecureAuth.hint': 'Not recommended: the user name and password would cross the network in plain text.',
    'emailServer.fromName': 'Sender name',
    'emailServer.fromAddress': 'Sender address',
    'emailServer.replyTo': 'Default reply-to address',
    'emailServer.replyTo.hint': 'Used when a message has no reply-to of its own. Optional.',
    'emailServer.save': 'Save email server',
    'emailServer.saved': 'Email server saved',
    'emailServer.warn.insecureAuth': 'Warning: sign-in without encryption is allowed. Passwords are sent in plain text.',
    'emailServer.test.title': 'Send a test email',
    'emailServer.test.description': 'Sends one message using the saved settings. Save first if you have changed anything.',
    'emailServer.test.to': 'Send to',
    'emailServer.test.send': 'Send test email',
    'emailServer.test.ok': 'The mail server accepted the test message.',
    'emailServer.test.failed': 'The test message was not sent: {error}',
    'emailServer.test.subject': 'CloudSign test email',
    'emailServer.test.body': 'This is a test message from CloudSign. If you can read it, outgoing email is working.',
    'error.email_server.host_required': 'Enter the mail server name.',
    'error.email_server.host_blocked': "That server name or address is internal or not allowed. Use your mail provider's public server name.",
    'emailServer.test.connectionFailed': 'Could not connect to the mail server. Check the server name, port and encryption setting.',
    'error.email_server.host_invalid': 'The server name is not valid. Enter a name or address only, with no http:// or port.',
    'error.email_server.insecure_auth': 'Signing in without encryption is refused. Choose STARTTLS or TLS, or tick "Allow sign-in without encryption".',
    'error.email_server.password_without_user': 'A password needs a user name.',
};
//# sourceMappingURL=smtp.js.map